import { render, staticRenderFns } from "./newPageYinsi.vue?vue&type=template&id=06215c62&scoped=true"
import script from "./newPageYinsi.vue?vue&type=script&lang=js"
export * from "./newPageYinsi.vue?vue&type=script&lang=js"
import style0 from "./newPageYinsi.vue?vue&type=style&index=0&id=06215c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06215c62",
  null
  
)

export default component.exports